import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Customer } from '../models/Customer';
import { ApiProvider } from '../providers/api.provider';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private currentSubject: BehaviorSubject<Customer[]>;
  public current: Observable<Customer[]>;
  public sectorID: number = 0;

  constructor(private apiProvider: ApiProvider) {
    this.currentSubject = new BehaviorSubject<Customer[]>(null);
  }

  public get currentValue(): Customer[] {
    return this.currentSubject.value;
  }

  async initialise(SectorID: number) {
    if(this.sectorID != SectorID){
      this.sectorID = SectorID;
      await this.apiProvider.LocationExceptionClient(SectorID).subscribe(
        (customer: Customer[]) => {
          console.log(customer);
          this.currentSubject = new BehaviorSubject<Customer[]>(
            customer
          );
          this.current =
            this.currentSubject.asObservable();
        },
        (err: HttpErrorResponse) => {
          this.currentSubject.next(null);
        }
      );

    }
  }
}
